import React, { PureComponent } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { store } from 'redux-rest-reducer';

import styled from 'styled-components';
import { FlexView, Separator } from '@cuemath/comps';

import {
  getAll as getStudentDemoList,
  invalidateList as invalidatestudentDemoList,
} from 'actions/student-demo-list';
import { get as getConfig } from 'actions/configs';
import { getAll as getPrograms } from 'actions/programs';
import { openModal, closeModal } from 'actions/modal';
import { get as getStudentSlots } from 'actions/student-slots';
import { patch as editStudentDemo } from 'actions/student-demos';

import StudentDemoList from './list';
import Pagination from 'modules/list/pagination';

import { RESULTS_PER_PAGE, TABLE_TYPE } from 'constants/list';
import {
  FORM_ACTIONS,
  MODAL_FORM,
  MODAL_CONFIRMATION_ACTIONS,
  teacherStatus,
} from 'constants/form';
import { USER_CONFIG, BATCHES_CONFIG } from 'constants/api';
import MODAL from 'constants/modal';

const FullFlexView = styled(FlexView)`
  width: 100%;
`;

class StudentDemoTab extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      searchKey: null,
      listData: null,
      studentId: null,
      studentPatch: store.patch(),
      archiveStudent: false,
      filterParam: null,
      regionFilter: null,
    };
  }

  static getDerivedStateFromProps(
    { studentDemoList, students, actions },
    { page, studentPatch, archiveStudent, studentId },
  ) {
    const listParams = {
      page,
      per_page: RESULTS_PER_PAGE,
      action: 'get',
      include_recent_class_id: true,
    };
    const newState = {};
    const newStudentPatch = store.patch(students, studentPatch.id + studentId);

    if (newStudentPatch.resolved && archiveStudent) {
      if (newStudentPatch.resolved.isPatched) {
        actions.invalidatestudentDemoList();
      } else if (newStudentPatch.resolved.isPatchingFailed) {
        alert(store.getError(newStudentPatch.resolved).message);
      }
      newState.archiveStudent = false;
      actions.closeModal();
    }

    newState.listData = store.getAll(studentDemoList, listParams);

    return newState;
  }

  getStudentDemoParamsFilters = addAction => {
    const { page } = this.state;
    let filterData = {
      page,
      per_page: RESULTS_PER_PAGE,
      include_recent_class_id: true,
    };

    if (addAction) {
      filterData = {
        ...filterData,
        action: 'get',
      };
    }

    return {
      listParams: {
        page,
        per_page: RESULTS_PER_PAGE,
        action: 'get',
        include_recent_class_id: true,
      },
      filterData,
    };
  };

  componentDidMount() {
    const { actions } = this.props;
    const { listParams, filterData } = this.getStudentDemoParamsFilters(true);

    actions.getStudentDemoList(listParams, filterData);
    actions.getConfig(USER_CONFIG);
    actions.getConfig(BATCHES_CONFIG);
    actions.getPrograms();
  }

  componentDidUpdate(prevProps, prevState) {
    const { actions, studentSlots } = this.props;
    const {
      page,
      searchKey,
      listData,
      studentId,
      archiveStudent,
      filterParam,
      regionFilter,
    } = this.state;
    const { listParams, filterData } = this.getStudentDemoParamsFilters();

    if (studentId && archiveStudent) {
      const studentSlotsGet = store.get(studentSlots, studentId);
      if (studentSlotsGet && studentSlotsGet.isLoaded) {
        const data = studentSlotsGet.data;
        if (data && Array.isArray(data) && data.length > 0) {
          alert('Expire Student Slots first');
          this.setState({
            archiveStudent: false,
          });
        } else {
          actions.openModal(
            MODAL_FORM.CONFIRMATION,
            {
              blocking: true,
              transparent: false,
            },
            { onConfirm: this.onConfirmation },
          );
        }
      }
    }

    if (searchKey) {
      filterData.search = searchKey;
    }

    if (regionFilter) {
      filterData.region = regionFilter;
    }

    const isListStale = !!(listData && listData.isStale);

    if (
      prevState.searchKey !== searchKey ||
      prevState.page !== page ||
      filterParam !== prevState.filterParam ||
      regionFilter !== prevState.regionFilter ||
      isListStale
    ) {
      if (filterParam) {
        filterParam.forEach(filter => {
          let value = filter.value;
          const key = filter.id;

          if (value && Array.isArray(value) && value.length) {
            filterData[key] = value;
          } else {
            if (value !== null) {
              filterData[key] = value;
            }
          }
        });
      }
      actions.getStudentDemoList(listParams, filterData);
    }
  }

  openDetailForm = ({ formType, data, modalForm }) => {
    const { actions } = this.props;

    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      actions.openModal(
        modalForm,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
          height: MODAL.HEIGHT,
        },
        { formType, data },
      );
    }
  };

  onCreatePaymentLink = student => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.PAYMENT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { student: student },
    );
  };

  openPhoneForm = ({ formType, data }) => {
    const { actions } = this.props;

    if (FORM_ACTIONS.hasOwnProperty(formType)) {
      actions.openModal(
        MODAL_FORM.PHONE,
        {
          size: 'custom',
          width: `${Math.ceil((window.innerWidth * 50) / 100)}px`,
          height: '280px',
        },
        { formType, data },
      );
    }
  };

  onPageChange = newPage => {
    this.setState({ page: newPage }, () => {});
  };

  onArchive = studentId => {
    const { actions } = this.props;
    this.setState({ studentId: studentId, archiveStudent: true }, () => {
      if (studentId) {
        actions.getStudentSlots(studentId, null, {
          student_id: studentId,
          status: teacherStatus.LIVE,
        });
      }
    });
  };

  onEnroll = student => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.STUDENT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, data: student, tab: 2 },
    );
  };

  onCreateDemo = studentId => {
    const { actions } = this.props;
    actions.openModal(
      MODAL_FORM.CREATE_DEMO_SLOT,
      {
        size: 'custom',
        width: `${Math.ceil((window.innerWidth * 60) / 100)}px`,
        height: MODAL.HEIGHT,
      },
      { formType: FORM_ACTIONS.CREATE, studentId: studentId },
    );
  };

  onFilter = filters => {
    this.setState({ filterParam: filters });
  };

  onRegionChange = region => {
    if (region && Array.isArray(region)) {
      let regionData = region.map(data => data.value);
      this.setState({ regionFilter: [...regionData] });
    } else {
      this.setState({ regionFilter: null });
    }
  };

  onConfirmation = value => {
    if (value === MODAL_CONFIRMATION_ACTIONS.CONFIRMED) {
      const { actions } = this.props;
      const {
        studentId,
        studentPatch: { id },
      } = this.state;
      const data = {
        state: 'INACT',
      };
      if (studentId) {
        actions.editStudentDemo(id + studentId, studentId, data);
      }
    } else {
      this.setState({
        archiveStudent: false,
      });
    }
  };

  onSearch = searchKey => {
    if (searchKey !== this.state.searchKey && (this.state.searchKey || searchKey))
      this.setState({ searchKey: searchKey });
  };

  render() {
    const { page, searchKey, listData } = this.state;

    return (
      <FullFlexView justifyContent="center" alignItems="center">
        <StudentDemoList
          tableData={!!listData ? listData.data : []}
          searchKey={searchKey}
          openDetailForm={this.openDetailForm}
          onArchive={this.onArchive}
          onEnroll={this.onEnroll}
          onCreateDemo={this.onCreateDemo}
          onCreatePaymentLink={this.onCreatePaymentLink}
          onFilter={this.onFilter}
          tableType={TABLE_TYPE.student}
          style={{ textAlign: 'center' }}
        />
        <Separator transparent height="25" />
        <Pagination
          page={page}
          perPage={RESULTS_PER_PAGE}
          count={null}
          onPageChange={this.onPageChange}
        />
      </FullFlexView>
    );
  }
}

export default connect(
  ({ studentDemoList, studentSlots, students, configs }) => ({
    studentDemoList,
    studentSlots,
    students,
    userConfig: store.get(configs, USER_CONFIG),
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        getStudentDemoList,
        getConfig,
        getPrograms,
        openModal,
        getStudentSlots,
        invalidatestudentDemoList,
        editStudentDemo,
        closeModal,
      },
      dispatch,
    ),
  }),
)(StudentDemoTab);
